import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getBranchTransactionPendingListApi,
  approveBranchTranApi,
} from "../../../apiservice/reports";
import { getBranchApi } from "../../../apiservice/setting";


export const fetchBranchTransferPendingList = createAsyncThunk(
  "branchTransferPending/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        fromBranchId: filters.fromBranchId || null,
      };
      const res = await getBranchTransactionPendingListApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch");
    }
  }
);

export const approveBranchTransaction = createAsyncThunk(
  "branchTransferPending/approve",
  async ({ tranId }, { rejectWithValue }) => {
    try {
      const res = await approveBranchTranApi({ tranId });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to approve");
    }
  }
);

export const fetchBranches = createAsyncThunk(
  "branchTransferPending/fetchBranches",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getBranchApi({ "without-self": "yes" });
      return res.data.message || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
